(function () {
  'use strict';

  var QUOTE_TEXT = /^(add to quote|request(\s+a|\s+custom|\s+expert)?\s*quote|get a quote)/i;
  var DEFAULT_QUOTE_HREF = '/pages/contact?topic=quote#tcb-contact-form';

  function stylizeQuoteButtons(scope) {
    var root = scope || document;
    root.querySelectorAll('a.tcb-page-btn, button.tcb-page-btn').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (!QUOTE_TEXT.test(text)) return;
      if (el.classList.contains('tcb-page-btn--quote')) return;
      el.classList.add('tcb-page-btn--quote');
      el.classList.remove('tcb-page-btn--primary');
    });
  }

  function isQuoteLink(el) {
    if (!el || el.tagName !== 'A') return false;
    var text = (el.textContent || '').trim();
    if (QUOTE_TEXT.test(text)) return true;
    if (
      el.classList.contains('tcb-quote') ||
      el.classList.contains('tcb-footer__quote-btn') ||
      el.classList.contains('tcb-header__quote-btn') ||
      el.classList.contains('tcb-mobile-menu__quote-btn')
    ) {
      return true;
    }
    return false;
  }

  function repairQuoteHref(href) {
    if (!href) return href;
    var raw = href;
    if (raw === '/contact' || raw.indexOf('/contact?') === 0 || raw.indexOf('/contact#') === 0) {
      raw = raw.replace(/^\/?contact/, '/pages/contact');
    }
    var decoded = raw;
    try {
      while (/%25[0-9a-f]{2}/i.test(decoded) || decoded.indexOf('%2Fpages%2Fcontact') > -1) {
        var next = decodeURIComponent(decoded);
        if (next === decoded) break;
        decoded = next;
      }
    } catch (e) {
      decoded = raw;
    }

    if (decoded.indexOf('/pages/contact') > -1) {
      return decoded.charAt(0) === '/' ? decoded : decoded.slice(decoded.indexOf('/pages/contact'));
    }

    if (/\/products\/(%2F|%252F)/i.test(raw) || /%2Fpages%2Fcontact/i.test(raw) || /%252Fpages%252Fcontact/i.test(raw)) {
      try {
        var broken = new URL(raw, window.location.origin);
        var tail = decodeURIComponent(broken.pathname.replace(/^\/products\//, ''));
        if (tail.indexOf('/pages/contact') === 0) {
          return tail + broken.search + broken.hash;
        }
      } catch (e2) {
        return href;
      }
    }

    return href;
  }

  function normalizeQuoteHref(href) {
    href = repairQuoteHref(href);
    if (!href || href === '#') return DEFAULT_QUOTE_HREF;
    if (href.indexOf('/pages/contact') === -1) {
      if (href.indexOf('/contact') === 0 || href.indexOf('contact') > -1) {
        href = href.replace(/^\/?contact/, '/pages/contact');
      } else {
        return href;
      }
    }
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return DEFAULT_QUOTE_HREF;
      if (window.TcbSecurity && !window.TcbSecurity.isSafeContactPath(url.pathname + url.search + url.hash)) {
        return DEFAULT_QUOTE_HREF;
      }
      if (!url.searchParams.get('topic')) {
        url.searchParams.set('topic', 'quote');
      }
      if (!url.hash || url.hash === '#tcb-finder-lead-form') {
        url.hash = 'tcb-contact-form';
      }
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  function markQuoteLink(link) {
    link.setAttribute('data-no-instant', '');
    if (!link.closest('.tcb-pro') && !link.closest('[data-tcb-build]')) {
      link.setAttribute('data-tcb-contact-fullpage', 'true');
    }
  }

  function shouldDeferToModal(link) {
    if (link.getAttribute('data-tcb-contact-fullpage') === 'true') return false;
    if (link.hasAttribute('data-tcb-contact-open')) return true;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/pages/contact') === -1) return false;
    var scope = document.querySelector('[data-tcb-build]') || document.querySelector('.tcb-pro');
    return !!(scope && scope.contains(link) && document.querySelector('[data-tcb-contact-modal]'));
  }

  function applyQuoteLink(link) {
    if (!isQuoteLink(link)) return;
    markQuoteLink(link);
    var normalized = normalizeQuoteHref(link.getAttribute('href'));
    if (normalized && normalized !== link.getAttribute('href')) {
      link.setAttribute('href', normalized);
    }
  }

  function ensureRfqFallback() {
    var rfqSlot = document.getElementById('tcb-rfq-app-slot');
    if (!rfqSlot || rfqSlot.querySelector('a.tcb-quote, button.tcb-quote, .sb-rfq-button, .cfp-button')) return;

    var productTitle = document.querySelector('.tcb-buy-box h1')?.textContent?.trim();
    var href = normalizeQuoteHref(
      DEFAULT_QUOTE_HREF.replace('#tcb-contact-form', '') +
        (productTitle ? '&product=' + encodeURIComponent(productTitle) : '') +
        '#tcb-contact-form'
    );
    var fallback = document.createElement('a');
    fallback.className = 'tcb-quote tcb-primary-rfq';
    fallback.href = href;
    fallback.textContent = 'Request a Quote';
    markQuoteLink(fallback);
    rfqSlot.appendChild(fallback);
  }

  function initLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('a[href]').forEach(applyQuoteLink);
    stylizeQuoteButtons(scope);
    if (!root) ensureRfqFallback();
  }

  function ensureNavigation(event) {
    var link = event.target.closest('a[href]');
    if (!link || !isQuoteLink(link)) return;
    if (shouldDeferToModal(link)) return;

    var href = normalizeQuoteHref(link.getAttribute('href') || link.href);
    if (!href || href === '#') href = DEFAULT_QUOTE_HREF;

    if (event.defaultPrevented) {
      if (document.querySelector('[data-tcb-contact-modal]:not([hidden])')) return;
      window.location.assign(href);
      return;
    }

    if ((link.getAttribute('href') || '') !== href) {
      link.setAttribute('href', href);
    }
  }

  function init() {
    initLinks();
    document.addEventListener('click', ensureNavigation, false);
    [400, 1200, 3000].forEach(function (ms) {
      setTimeout(ensureRfqFallback, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLinks(event.target);
  });
})();
